import React from "react";
import AppTemplate from "../components/Form2";

const Form2: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Form2;
